import gql from 'graphql-tag';

export const FRAGMENT_SUB_TEMPLATE = gql`
  fragment SubTemplate on SubTemplate {
    id
    name
    description
    generationTool
    tags
    questions {
      question
      mandatory
      placeholder
    }
  }
`;
